module.exports = __webpack_public_path__ + "img/4.31a24aef.png";